import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

export interface EmailSignup {
  email: string;
  timestamp: Timestamp;
  source: string;
  userAgent?: string;
}

export const captureEmail = async (
  email: string,
  source = 'transmission_page'
): Promise<boolean> => {
  try {
    await addDoc(collection(db, 'emailSignups'), {
      email: email.toLowerCase().trim(),
      timestamp: Timestamp.now(),
      source,
      userAgent: navigator.userAgent,
    });
    return true;
  } catch (error) {
    console.error('Error capturing email:', error);
    return false;
  }
};

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}; 